import { createStyles, keyframes, rem } from '@mantine/core'

export const ripple = keyframes({
  from: { opacity: 1, transform: 'scale(0)' },
  to: { opacity: 0, transform: 'scale(1)' },
})

type StylesParams = {
  showAnimation: boolean
  bgImage: string
  expandWidget: boolean
}

export default createStyles(
  (theme, { bgImage, expandWidget, showAnimation }: StylesParams) => {
    return {
      root: {
        position: 'fixed',
        bottom: rem(16),
        right: rem(16),
        [theme.fn.largerThan('sm')]: {
          bottom: rem(32),
          right: rem(32),
        },
      },
      wrapper: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        gap: rem(8),
        '.ripple': {
          position: 'absolute',
          width: '120px',
          height: '120px',
          zIndex: -1,
          left: '50%',
          top: '50%',
          opacity: '0',
          margin: '-60px 0 0 -60px',
          borderRadius: '100px',
          backgroundColor: '#ed184f',
          backgroundImage: `linear-gradient(90deg, #fd5581, #fd8b55)`,
          ...(showAnimation && {
            animation: `${ripple} 1.8s infinite`,
            '&:nth-child(2)': {
              animationDelay: '.3s',
            },
            // '&:nth-child(3)': {
            //   animationDelay: '.6s',
            // },
          }),
        },
      },
      widget: {
        boxShadow: '0 24px 32px 0px #0000001a',
        [theme.fn.smallerThan('sm')]: {
          ...(expandWidget && {
            borderRadius: 0,
          }),
        },
        [theme.fn.largerThan('sm')]: {
          borderRadius: rem(16),
          width: rem(480),
          height: rem(640),
        },
      },
      widgetHeader: {},
      widgetAction: {},
      welcomeBox: {
        position: 'absolute',
        right: '10%',
        bottom: '25%',
        cursor: 'pointer',
        [theme.fn.largerThan('md')]: {
          right: '35%',
          bottom: '35%',
        },
      },
      welcomeBoxInner: {
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        width: rem(210),
        height: rem(159),
        padding: `${rem(8)} ${rem(50)} ${rem(16)} ${rem(22)}`,
        [theme.fn.largerThan('sm')]: {
          padding: `${rem(6)} ${rem(30)} ${rem(16)} ${rem(18)}`,
        },
      },
      welcomeText: {
        color: '#fff',
      },
      welcomeClose: {
        position: 'absolute',
        left: rem(-9),
        top: rem(-9),
        border: `3px solid transparent`,
        borderRadius: '50%',
        backgroundColor: theme.colors.gray[8],
      },
      indicatorCommon: {
        width: rem(12),
        height: rem(12),
        bottom: 0,
        right: rem(12),
        top: 'auto',
      },
      indicatorIndicator: {
        pointerEvents: 'none',
      },
      popoverDropdown: {
        padding: 0,
        border: 0,
        backgroundColor: 'transparent',
        position: 'fixed!important' as any,
        [theme.fn.smallerThan('sm')]: {
          ...(expandWidget
            ? {
                top: '0!important' as any,
                bottom: '0!important' as any,
              }
            : {
                top: 'auto!important' as any,
                bottom: '16px!important' as any,
              }),
        },
        [theme.fn.largerThan('sm')]: {
          top: 'auto!important',
          bottom: '32px!important',
        },
      },
    }
  },
)
